var clone = require('clone');
module.exports = function fixRange(opts) {
  opts = clone(opts);
  var reverse = opts.reverse;
  var end = opts.max || opts.end;
  var start = opts.min || opts.start;
  var range = [start, end];
  if (start != null && end != null) range.sort();
  if (reverse) range = range.reverse();
  opts.start = range[0];
  opts.end = range[1];
  delete opts.min;
  delete opts.max;
  return opts;
};